<template>
    <div>
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
       <br>
        <v-card flat>
           <v-skeleton-loader
                v-if="loadingAYChart"
                class="mx-auto"
                max-width="700"
                type="image">
            </v-skeleton-loader>

            <div v-else-if="appraisal_score_by_ay.length">
                <chart
                    style="width: 850px; height: 400px;"
                    auto-resize
                    :options="faculty_appraisal_score_ay">
                </chart>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No appraisal data available
            </div>

            <v-divider v-if="loadingAppraisalScore || table_data.length" class="my-5"></v-divider>
            <center v-if="loadingAppraisalScore || table_data.length">
                <v-col cols="12" sm="4" md="4">
                    <v-select v-model="selectedEmployeeType" :items="employeeTypes" label="Employee Type"
                    @change="updateChartData" outlined dense></v-select>
                </v-col>                
            </center>


            <v-skeleton-loader v-if="loadingAppraisalScore" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>
            <div v-else>
                <chart :style="`width: 850px; height: ${table_data.length * 35}px;`" auto-resize
                    :options="faculty_appraisal_score_data"></chart>
            </div>

        </v-card>
    </div>
</template>

<script>
import axios from "axios";

import UnderDevelopement from '../shared/UnderDevelopement.vue';
export default {

    props: [
        'selected_ay',
        'selected_semester',
        'selected_standard',
        'selected_div',
        'selected_course',
        'selected_learner',
        'render1',
    ],
    components: { UnderDevelopement },
    data() {
        return {
            color: "",
            snackbar: false,
            snackbar_msg: null,
            loadingAppraisalScore: true,
            table_data: [],
            appraisal_score_by_ay: [],
            selectedEmployeeType: "All", // default
            employeeTypes: ["All", "Teaching", "Non-Teaching"], // available options
            original_table_data: [],
            loadingAYChart: true,
            faculty_appraisal_score_data: {
                title: {
                    text: "Faculty Appraisal Score",
                    left: "center",
                },
                color: [
                    {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            { offset: 0, color: "#90e0ef" },
                            { offset: 1, color: "#00b4d8" },
                        ],
                    },
                ],
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "shadow" },
                    formatter: "{b}: {c}%",
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: { show: true, title: "Save As Image" },
                    },
                },
                legend: {
                    data: ["Score"],
                    bottom: 0,
                },
                grid: {
                    top: 100,
                    bottom: 50,
                    left: 120,
                    right: 50,
                    containLabel: true,
                },

                xAxis: {
                    type: "value",
                    min: 0,
                    max: 100,
                    interval: 10,
                    name: "Percentage",
                    axisLabel: { formatter: "{value}%" },
                },
                yAxis: {
                    type: "category",
                    data: [],
                    name: "Employees",
                    axisLabel: {
                        fontSize: 11,
                        interval: 0,
                        width: 200,
                        overflow: "truncate",
                        margin: 8,
                    },

                },
                series: [
                    {
                        name: "Score",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "right",
                            formatter: "{c}%",
                        },
                        itemStyle: {
                            borderRadius: [4, 4, 4, 4],
                        },
                    },
                ],
            },
            faculty_appraisal_score_ay: {
                title: {
                    text: "Faculty Appraisal Score - AY",
                    left: "center",
                },
                color: [
                    {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            { offset: 0, color: "#a7c957" }, // top
                            { offset: 1, color: "#6a994e" }  // bottom
                        ],
                    },
                ],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                        },
                    },
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        magicType: {
                            show: true,
                            type: ["line", "bar", "stack"],
                            title: {
                                line: "Switch to Line Chart",
                                bar: "Switch to Bar Chart",
                                stack: "Switch to Stack Chart",
                            },
                        },
                        restore: { show: true, title: "Restore" },
                        saveAsImage: {
                            show: true,
                            title: "Save As Image",
                        },
                    },
                },
                calculable: true,
                legend: {
                    data: ["Academic Year"],
                    itemGap: 15,
                    bottom: 0,
                },
                grid: {
                    top: "20%",
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisLabel: {
                        margin: 0,
                        rotate: 45,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                    name: "",
                    nameLocation: "end",
                    offset: 10,
                },
                yAxis: {
                    type: "value",
                    name: "Score (in percentage)",
                    nameLocation: "end",
                    offset: 10,
                },
                series: [
                    {
                        name: "Academic Year",
                        data: [],
                        type: "bar",
                        label: {
                            show: true,
                            position: "top",
                        },
                    },
                ],
            },
        };
    },
    mounted() {
        this.onload();
        this.init();

    },
    methods: {
        showSnackbar(color, msg) {
            this.snackbar = true;
            this.color = color;
            this.snackbar_msg = msg;
        },
        async onload() {
            const data = {
                selected_ay: this.selected_ay,
            }
            const res = await axios.post("/AdminDashboard/getAppraisalAnalytics", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.table_data = res.data.table_data.map(item => ({
                            employee: item.employee,
                            percentage: parseFloat(Number(item.percentage).toFixed(2)) || 0,
                            employee_type: item.employee_type
                        }));

                        // Save a copy of the original data
                        this.original_table_data = [...this.table_data];

                        this.updateChartData();
                    }
                    else {
                        this.showSnackbar("error", res.data.msg || "Failed to load data");
                    }
                })
                .catch((err) => {
                    this.showSnackbar("error", "Something went wrong");
                })
                .finally(() => {
                    this.loadingAppraisalScore = false;
                });
        },
        updateChartData() {
            let filteredData = this.selectedEmployeeType === "All"
                ? this.original_table_data
                : this.original_table_data.filter(
                    item => item.employee_type === this.selectedEmployeeType
                );

            this.faculty_appraisal_score_data.yAxis.data = filteredData.map(
                item => item.employee
            );
            this.faculty_appraisal_score_data.series[0].data = filteredData.map(
                item => item.percentage
            );
        },
        async init() {
            this.loadingAYChart = true;

            const data = {
                selected_ay: this.selected_ay,
            }

            try {
                const res = await axios.post("/AdminDashboard/getAvgAppraisalForLastFourYears", data);

                if (res.data.flag === "YES") {
                    this.appraisal_score_by_ay = res.data.result || [];

                    this.faculty_appraisal_score_ay.xAxis.data =
                        this.appraisal_score_by_ay.map(item => item.ay);

                    this.faculty_appraisal_score_ay.series[0].data =
                        this.appraisal_score_by_ay.map(item => item.avg_percentage);
                } else {
                    this.appraisal_score_by_ay = [];
                }
            } catch (e) {
                this.showSnackbar("error", "Failed to load data");
                this.appraisal_score_by_ay = [];
            } finally {
                this.loadingAYChart = false;
            }
        },
    }
};
</script>

<style scoped></style>
